const DOCUMENT = 'ADD_NEW_PRICE_LIST_';

const actions = {
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  LOAD_FORM_DATA_REQUEST: DOCUMENT + 'LOAD_FORM_DATA_REQUEST',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  LOAD_FORM_DATA_ERROR: DOCUMENT + 'LOAD_FORM_DATA_ERROR',
  APPLY_BULK_MARKUP: DOCUMENT + 'APPLY_BULK_MARKUP',
  CREATE_PRICE_LIST_REQUEST: DOCUMENT + 'CREATE_PRICE_LIST_REQUEST',
  CREATE_PRICE_LIST_SUCCESS: DOCUMENT + 'CREATE_PRICE_LIST_SUCCESS',
  CREATE_PRICE_LIST_ERROR: DOCUMENT + 'CREATE_PRICE_LIST_ERROR',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  loadFormDataRequest: data => ({
    type: actions.LOAD_FORM_DATA_REQUEST,
    payload: data,
  }),

  loadFormDataSuccess: data => ({
    type: actions.LOAD_FORM_DATA_SUCCESS,
    payload: data,
  }),

  loadFormDataError: data => ({
    type: actions.LOAD_FORM_DATA_ERROR,
    payload: data,
  }),

  createPriceListRequest: data => ({
    type: actions.CREATE_PRICE_LIST_REQUEST,
    payload: data,
  }),

  createPriceListSuccess: data => ({
    type: actions.CREATE_PRICE_LIST_SUCCESS,
    payload: data,
  }),

  createPriceListError: data => ({
    type: actions.CREATE_PRICE_LIST_ERROR,
    payload: data,
  }),

  applyBulkMarkup: data => ({
    type: actions.APPLY_BULK_MARKUP,
    payload: data,
  }),
};

export default actions;
